var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"m-3 p-2 d-flex align-items-center border border-secondary rounded"},[_c('strong',[_vm._v("Loading...")]),_c('b-spinner',{staticClass:"ml-auto"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }